"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InstellingController = void 0;
class InstellingController {
    constructor($scope, applicationService) {
        $scope.clearCache = () => {
            applicationService.clearCache();
        };
    }
}
exports.InstellingController = InstellingController;
InstellingController.$inject = ['$scope', 'applicationService'];
